import { Box, Typography, Select } from "@bca/ui-library";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { SortOption } from "./vehicle-search-details/vehicleSearch.type";

const StyledOption = styled.option<{
  children: React.ReactNode;
  value: string;
}>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;

const SortingOptions: React.FunctionComponent<{
  optionList: SortOption;
  updateUrl: (href: string) => void;
  allAppliedFilters: any;
}> = ({ optionList, updateUrl, allAppliedFilters }) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const resetPagination = (url) => {
    url.searchParams.delete("page");
    return url;
  };

  const getUpdatedSortURL = (optionKey) => {
    let url = new URL(window.location.href);
    url = resetPagination(url);
    url.searchParams.set("sort", optionKey);
    return url;
  };

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
    updateUrl(getUpdatedSortURL(event.target.value).href);
  };

  useEffect(() => {
    const getCurrentOption = () => {
      const url = new URL(window.location.href);
      const optionKey = url.searchParams.get("sort");
      if (Boolean(optionKey)) {
        return optionKey;
      } else return { key: null, label: null };
    };

    setSelectedOption(getCurrentOption());
  }, [optionList]);

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <Typography
        variant="body"
        mr="10px"
        css={`
          @media screen and (max-width: 470px) {
            display: none;
          }
        `}
      >
        Sort by
      </Typography>
      <Select
        id="sorting-options"
        value={Boolean(selectedOption) ? selectedOption : ""}
        onChange={handleChange}
        width={{ mobile: "150px", tablet: "210px", desktop: "210px" }}
      >
        {Boolean(optionList) &&
          optionList.options.map((option) => (
            <StyledOption key={option.key} value={option.key}>
              {option.label}
            </StyledOption>
          ))}
      </Select>
    </Box>
  );
};

export default SortingOptions;
